module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="editor-region"></div>\n<div class="widget-toolbox"></div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/editor/EditorView.tpl
// module id = 3020
// module chunks = 0